import { inject } from '@angular/core';
import {
  type ActivatedRouteSnapshot,
  type CanActivateFn,
  Router,
} from '@angular/router';
import { AuthDataAccess } from '@app/auth/data-access/auth.data-access';

export const profileGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthDataAccess);

  const user = auth.getUserInfo();
  const data = route.data as unknown as { roleId: number[] };

  if (user?.arrOpciones.includes(data.roleId[0])) {
    return true;
  } else {
    const router = inject(Router);
    router.navigate(['/dashboard']);
    return false;
  }
};
